// Import model
import { OtgCatalogStyleCondition } from '../models/OtgCatalogStyleCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgCatalogStyleIndexedFields } from '../models/OtgCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgCatalogStyleIndexedFieldsSerializer } from './OtgCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgCatalogStyleCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgCatalogStyleConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgCatalogStyleCondition instance
   */
  static deserialize(json: string): OtgCatalogStyleCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgCatalogStyleCondition instance
   */
  static fromObject(obj: any): OtgCatalogStyleCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgCatalogStyleCondition');
    }


    const instance: OtgCatalogStyleCondition = {
      fieldName: obj['fieldName'] as OtgCatalogStyleIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgCatalogStyleCondition instances
   */
  static deserializeArray(json: string): OtgCatalogStyleCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgCatalogStyleCondition instance to a JSON string
   */
  static serialize(instance: OtgCatalogStyleCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgCatalogStyleCondition instance to a plain object
   */
  static toObject(instance: OtgCatalogStyleCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgCatalogStyleCondition instances to a JSON string
   */
  static serializeArray(instances: OtgCatalogStyleCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
